import styled from "@emotion/styled";
import React, { memo } from "react";
import { VariableSizeList, areEqual } from "react-window";

// Deactivating this for now - removing it is a breaking change.
// See https://git.lab.smartsheet.com/design-systems-team/lodestar-core/-/issues/493
// eslint-disable-next-line @typescript-eslint/no-unused-vars,no-unused-vars
const VirtualizedMenuListContainer = styled("div")`
    // Can't just use padding OR margin because of the way react-window needs
    // to calc heights :)
    padding-bottom: 4px;
    margin-top: 4px;
`;
// See https://react-window.now.sh/#/examples/list/memoized-list-items
// This helps a LOT because for the most part the object is the same
// just isFocused is changed on items the user is interacting with.
const VirtualItem = /*#__PURE__*/memo(_ref => {
  let {
    data,
    index,
    style
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    style: style
  }, data[index]);
}, areEqual);
VirtualItem.displayName = "VirtualItem";

/**
 * Leverages react-window's FixedSizeList to virtualize the menu list. This implementation works
 * best if the menu options have a fixed size.
 *
 * If the menu options don't have a fixed size, adjusting the itemHeight to fit the maximum-height
 * option will produce the best results, but ultimately you might want to provide a different
 * virtualization via the components overrides (perhaps using react-window's VariableSizeList).
 *
 * @deprecated This component is being removed in V6+, February 2025, in favor of the `SelectV2/MultiSelectV2` components.
 */
export const VirtualizedMenuList = props => {
  const {
    className,
    children,
    innerRef,
    maxHeight,
    getOptionHeight
  } = props;
  const childrenArray = React.Children.toArray(children);
  return /*#__PURE__*/React.createElement(VariableSizeList, {
    className: className,
    width: "100%",
    height: maxHeight,
    itemData: childrenArray,
    itemCount: childrenArray.length,
    itemSize: getOptionHeight,
    outerElementType: VirtualizedMenuListContainer,
    innerRef: innerRef
  }, VirtualItem);
};
//# sourceMappingURL=VirtualizedMenuList.js.map